module.exports = {"pathContext":{"name":"LabDevice","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/object-lab-device.json
// module id = 1818
// module chunks = 25321166745878